/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { POSITION_BANNER } from '../POSITION_BANNER';
import { useTranslation } from 'react-i18next';
import bg_logo from './../../../assets/Images/svg/bg_cookie_logo.svg';
import styled from 'styled-components';

const CloseButton = styled.div`
    path {
        fill: currentColor;
        --tw-text-opacity: 1;
        stroke: rgb(209 213 219 / var(--tw-text-opacity));
    }
    svg {
        stroke: currentColor;
        --tw-text-opacity: 1;
    }
`;

const CookieConsent = ({ platform, previewLang, values, logo }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);

    const [positionIconStyle, setPositionIconStyle] = useState();
    const [positionBannerStyle, setPositionBannerStyle] = useState();
    const [positionButtonStyle, setPositionButtonStyle] = useState();

    const LayoutPositionBanner = (position, platform) => {
        if (position === 'top' || position === 'bottom') {
            switch (platform) {
                case 'Desktop':
                    return setPositionButtonStyle({
                        layout: 'flex',
                        content: '',
                        contentGap: 'gap-1',
                        button: 'space-y-2',
                        buttonWidth: 'min-w-44',
                        poweredPosition: 'pb-2',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
                case 'Tablet':
                    return setPositionButtonStyle({
                        layout: 'flex',
                        content: 'col-span-3',
                        contentGap: 'gap-1',
                        button: 'space-y-2',
                        buttonWidth: 'w-full',
                        poweredPosition: 'pb-2',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
                case 'Mobile':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 space-y-2',
                        buttonWidth: 'w-[100%]',
                        poweredPosition: 'justify-center',
                        showBorder: false,
                        positionTitle: 'text-center',
                    });
                default:
                    setPositionButtonStyle({
                        layout: 'flex',
                        content: 'col-span-3',
                        contentGap: 'gap-1',
                        button: 'space-y-2',
                        buttonWidth: 'min-w-44',
                        poweredPosition: '',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
            }
        }
        if (position === 'top-center' || position === 'bottom-center') {
            switch (platform) {
                case 'Desktop':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-center items-center gap-x-4',
                        buttonWidth: 'min-w-44',
                        poweredPosition: 'justify-end',
                        showBorder: false,
                        positionTitle: 'text-left',
                    });
                case 'Tablet':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-center items-center gap-x-4',
                        buttonWidth: 'min-w-36',
                        poweredPosition: 'justify-end',
                        showBorder: false,
                        positionTitle: 'text-left',
                    });
                case 'Mobile':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 space-y-2',
                        buttonWidth: 'w-[100%]',
                        poweredPosition: 'justify-center',
                        showBorder: false,
                        positionTitle: 'text-center',
                    });
                default:
                    setPositionButtonStyle({
                        layout: '',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-center items-center gap-x-4',
                        buttonWidth: 'min-w-44',
                        poweredPosition: 'justify-end',
                        showBorder: false,
                        positionTitle: 'text-left',
                    });
            }
        }
        if (position === 'top-fully' || position === 'bottom-fully') {
            switch (platform) {
                case 'Desktop':
                    return setPositionButtonStyle({
                        layout: 'flex',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-start items-center gap-x-4',
                        buttonWidth: 'min-w-44',
                        poweredPosition: 'pb-2',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
                case 'Tablet':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-start items-center gap-x-4',
                        buttonWidth: 'min-w-36',
                        poweredPosition: 'pb-2',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
                case 'Mobile':
                    return setPositionButtonStyle({
                        layout: 'flex flex-col',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 space-y-2',
                        buttonWidth: 'w-[100%]',
                        poweredPosition: 'justify-center',
                        showBorder: false,
                        positionTitle: 'text-center',
                    });
                default:
                    setPositionButtonStyle({
                        layout: 'flex',
                        content: 'col-span-4',
                        contentGap: 'gap-4',
                        button: 'col-span-4 flex flex-row-reverse justify-start items-center gap-x-4',
                        buttonWidth: 'min-w-44',
                        poweredPosition: '',
                        showBorder: true,
                        positionTitle: 'text-left',
                    });
            }
        }
    };

    useEffect(() => {
        // console.log('position',values?.customizeStyle?.position)

        const PositionIcon = async () => {
            switch (values?.customizeStyle?.positionIcon) {
                case 'bottom-left':
                    return setPositionIconStyle('bottom-[-1em] left-[2em]');
                case 'bottom-right':
                    return setPositionIconStyle('bottom-[-1em] right-[2em]');
                default:
                    return setPositionIconStyle('bottom-[-1em] left-[2em]');
            }
        };
        const PositionBanner = async () => {
            if (values?.customizeStyle?.position === POSITION_BANNER.TOP) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'top-[-38em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'top-[-40em] left-[-109px] scale-[0.8]'
                            : 'top-[-42em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1080px] rounded-2xl mx-[23px]'
                            : platform === 'Tablet'
                            ? 'w-[700px] rounded-2xl mx-[12px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.BOTTOM
            ) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'bottom-[-4.5em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'bottom-[-2.5em] left-[-109px] scale-[0.8]'
                            : 'bottom-[-7.5em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1080px] rounded-2xl mx-[23px]'
                            : platform === 'Tablet'
                            ? 'w-[700px] rounded-2xl mx-[12px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.TOP_CENTER
            ) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'top-[-38em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'top-[-40em] left-[-109px] scale-[0.8]'
                            : 'top-[-42em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1080px] rounded-2xl mx-[23px]'
                            : platform === 'Tablet'
                            ? 'w-[700px] rounded-2xl mx-[12px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else if (
                values?.customizeStyle?.position ===
                POSITION_BANNER.BOTTOM_CENTER
            ) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'bottom-[-4.5em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'bottom-[-2.5em] left-[-109px] scale-[0.8]'
                            : 'bottom-[-7.5em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1080px] rounded-2xl mx-[23px]'
                            : platform === 'Tablet'
                            ? 'w-[700px] rounded-2xl mx-[12px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.BOTTOM_FULL
            ) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'bottom-[-6em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'bottom-[-4.5em] left-[-109px] scale-[0.8]'
                            : 'bottom-[-7.5em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1125px]'
                            : platform === 'Tablet'
                            ? 'w-[720px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.TOP_FULL
            ) {
                return setPositionBannerStyle({
                    position:
                        platform === 'Tablet'
                            ? 'top-[-40em] left-[-7.7em] scale-[0.7]'
                            : platform === 'Desktop'
                            ? 'top-[-34rem] left-[-109px] scale-[0.8]'
                            : 'top-[-42em] left-[-7em] scale-[0.65]',
                    contentWidth:
                        platform === 'Desktop'
                            ? 'w-[1125px]'
                            : platform === 'Tablet'
                            ? 'w-[720px]'
                            : 'w-[525px] rounded-2xl mx-[15px]',
                });
            } else {
                return setPositionBannerStyle({
                    position: 'bottom-[-15em]',
                    contentWidth: 'w-[1080px] rounded-2xl mx-[23px]',
                });
            }
        };
        const PositionButton = async () => {
            if (values?.customizeStyle?.position === POSITION_BANNER.TOP) {
                return LayoutPositionBanner('top', platform);
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.BOTTOM
            ) {
                return LayoutPositionBanner('bottom', platform);
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.TOP_CENTER
            ) {
                return LayoutPositionBanner('top-center', platform);
            } else if (
                values?.customizeStyle?.position ===
                POSITION_BANNER.BOTTOM_CENTER
            ) {
                return LayoutPositionBanner('bottom-center', platform);
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.BOTTOM_FULL
            ) {
                return LayoutPositionBanner('top-fully', platform);
            } else if (
                values?.customizeStyle?.position === POSITION_BANNER.TOP_FULL
            ) {
                return LayoutPositionBanner('bottom-fully', platform);
            } else {
                return LayoutPositionBanner('bottom', platform);
            }
        };

        PositionIcon();
        PositionBanner();
        PositionButton();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    return (
        <div
            className={`h-[580px] ${values?.customizeStyle?.fontFamily?.toLowerCase()}`}
        >
            <div className="py-48 flex flex-col items-center text-center">
                <img src={bg_logo} alt="bg_logo" />
            </div>
            {isOpen ? (
                <div className="relative ">
                    <div
                        className={`absolute ${positionBannerStyle?.position}`}
                    >
                        <div
                            className={` ${positionBannerStyle?.contentWidth} shadow-md relative`}
                            style={{
                                background: `${values?.customizeStyle?.backgroundThemeColor}`,
                            }}
                        >
                            <div
                                className={`pt-6 px-4 ${positionButtonStyle?.positionTitle} font-semibold`}
                                style={{
                                    color: `${values?.customizeStyle?.header?.color}`,
                                    fontSize: `${values?.customizeStyle?.header?.fontSize}`,
                                }}
                            >
                                {previewLang === 'en' ? (
                                    <>{values?.customizeContent?.titleEn}</>
                                ) : (
                                    <>{values?.customizeContent?.titleTh}</>
                                )}
                            </div>
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* Layout Detail */}
                            {/* ${platform === "Moblie" ? "flex flex-col" : "flex justify-between gap-x-4"}  */}
                            <div
                                className={`${positionButtonStyle?.layout}
                     ${positionButtonStyle?.contentGap} px-4 
                     ${!values?.customizeStyle?.hiddenLogo ? 'pb-6' : ''}`}
                            >
                                {/* positionButtonStyle?.content */}
                                <div
                                    className={`${
                                        platform === 'Mobile'
                                            ? 'basis-[100%]'
                                            : 'basis-[75%]'
                                    }`}
                                >
                                    <div
                                        className={`text-[${values?.customizeStyle?.description?.fontSize}]`}
                                        style={{
                                            whiteSpace: 'break-spaces',
                                            color: `${values?.customizeStyle?.description?.color}`,
                                        }}
                                    >
                                        {previewLang === 'en' ? (
                                            <>
                                                {
                                                    values?.customizeContent
                                                        ?.contentEn
                                                }{' '}
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    values?.customizeContent
                                                        .contentTh
                                                }{' '}
                                            </>
                                        )}
                                        {values?.customizeContent
                                            ?.isDisplayCookiePolicy &&
                                            !values?.customizeContent
                                                .isDisplayPrivacyPolicy && (
                                                <span
                                                    style={{
                                                        display:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'block'
                                                                : 'unset',
                                                        textAlign:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'center'
                                                                : 'left',
                                                    }}
                                                >
                                                    <a
                                                        href={
                                                            previewLang === 'en'
                                                                ? values
                                                                      ?.customizeContent
                                                                      ?.cookiePolicyUrlEn
                                                                : values
                                                                      ?.customizeContent
                                                                      ?.cookiePolicyUrlTh
                                                        }
                                                        className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStyle?.hyperlink?.color}] hover:underline`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            color: `${values?.customizeStyle?.hyperlink?.color}`,
                                                            fontSize: `${values?.customizeStyle?.hyperlink?.fontSize}`,
                                                            // textDecorationColor: `${values?.customizeStyle?.hyperlink?.color}`,
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayCookieNameEn
                                                            : values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayCookieNameTh}
                                                    </a>
                                                </span>
                                            )}

                                        {values?.customizeContent
                                            ?.isDisplayPrivacyPolicy &&
                                            !values?.customizeContent
                                                ?.isDisplayCookiePolicy && (
                                                <span
                                                    style={{
                                                        display:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'block'
                                                                : 'unset',
                                                        textAlign:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'center'
                                                                : 'left',
                                                    }}
                                                >
                                                    <a
                                                        href={
                                                            previewLang === 'en'
                                                                ? values
                                                                      ?.customizeContent
                                                                      ?.privacyPolicyUrlEn
                                                                : values
                                                                      ?.customizeContent
                                                                      ?.privacyPolicyUrlTh
                                                        }
                                                        className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStyle?.hyperlink?.color}] hover:underline`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            color: `${values?.customizeStyle?.hyperlink?.color}`,
                                                            fontSize: `${values?.customizeStyle?.hyperlink?.fontSize}`,
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayPrivacyNameEn
                                                            : values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayPrivacyNameTh}
                                                    </a>
                                                </span>
                                            )}

                                        {values?.customizeContent
                                            ?.isDisplayCookiePolicy &&
                                            values?.customizeContent
                                                ?.isDisplayPrivacyPolicy && (
                                                <span
                                                    style={{
                                                        display:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'block'
                                                                : 'unset',
                                                        textAlign:
                                                            platform ===
                                                            'Mobile'
                                                                ? 'center'
                                                                : 'left',
                                                        fontSize: `${values?.customizeStyle?.hyperlink?.fontSize}`,
                                                    }}
                                                >
                                                    <a
                                                        href={
                                                            previewLang === 'en'
                                                                ? values
                                                                      ?.customizeContent
                                                                      ?.cookiePolicyUrlEn
                                                                : values
                                                                      ?.customizeContent
                                                                      ?.cookiePolicyUrlTh
                                                        }
                                                        className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStyle?.hyperlink?.color}] hover:underline`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            color: `${values?.customizeStyle?.hyperlink?.color}`,
                                                            fontSize: `${values?.customizeStyle?.hyperlink?.fontSize}`,
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayCookieNameEn
                                                            : values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayCookieNameTh}
                                                    </a>
                                                    {' & '}
                                                    <a
                                                        href={
                                                            previewLang === 'en'
                                                                ? values
                                                                      ?.customizeContent
                                                                      ?.privacyPolicyUrlEn
                                                                : values
                                                                      ?.customizeContent
                                                                      ?.privacyPolicyUrlTh
                                                        }
                                                        className={`cursor-pointer underline hover:opacity-80 hover:text-[${values?.customizeStyle?.hyperlink?.color}] hover:underline`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            color: `${values?.customizeStyle?.hyperlink?.color}`,
                                                            fontSize: `${values?.customizeStyle?.hyperlink?.fontSize}`,
                                                        }}
                                                    >
                                                        {previewLang === 'en'
                                                            ? values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayPrivacyNameEn
                                                            : values
                                                                  ?.customizeContent
                                                                  ?.hyperLinkDisplayPrivacyNameTh}
                                                    </a>
                                                </span>
                                            )}
                                    </div>
                                </div>
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                {/* Layout Button */}
                                <button
                                    type="button"
                                    onClick={() => setIsOpen(false)}
                                    className={`${
                                        positionButtonStyle?.button
                                    } ${
                                        (platform === 'Mobile' ||
                                            platform === 'Tablet') &&
                                        values?.customizeStyle?.position ===
                                            POSITION_BANNER.BOTTOM &&
                                        values?.customizeStyle?.position ===
                                            POSITION_BANNER.TOP
                                            ? 'basis-[100%]'
                                            : platform === 'Mobile'
                                            ? 'basis-[100%]'
                                            : 'basis-[25%] px-6'
                                    }  text-center `}
                                >
                                    <CloseButton
                                        className="cursor-pointer"
                                        hidden={
                                            platform === 'Desktop' &&
                                            (values?.customizeStyle
                                                ?.position ===
                                                POSITION_BANNER.TOP_FULL ||
                                                values?.customizeStyle
                                                    ?.position ===
                                                    POSITION_BANNER.BOTTOM_FULL)
                                                ? !values?.customizeStyle
                                                      ?.closeable
                                                : true
                                        }
                                        style={{
                                            color: `${values?.customizeStyle?.buttonThemeColor}`,
                                        }}
                                    >
                                        <svg
                                            width="30"
                                            height="30"
                                            viewBox="0 0 21 21"
                                            fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M15.75 5.25L5.25 15.75"
                                                strokeWidth="1.96875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M5.25 5.25L15.75 15.75"
                                                strokeWidth="1.96875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </CloseButton>
                                    <div hidden={false}>
                                        <Button
                                            block={
                                                values?.customizeStyle
                                                    ?.position ===
                                                    POSITION_BANNER.TOP ||
                                                values?.customizeStyle
                                                    ?.position ===
                                                    POSITION_BANNER.BOTTOM
                                            }
                                            size="large"
                                            type="primary"
                                            className={`h-auto ${positionButtonStyle?.buttonWidth} font-medium hover:opacity-80 hover:bg-[${values?.customizeStyle?.buttonThemeColor}] hover:border-[${values?.customizeStyle?.buttonThemeColor}] focus:bg-[${values?.customizeStyle?.buttonThemeColor}] focus:border-[${values?.customizeStyle?.buttonThemeColor}]`}
                                            onClick={() => setIsOpen(false)}
                                            style={{
                                                color: `${values?.customizeStyle?.button?.color}`,
                                                fontSize: `${values?.customizeStyle?.button?.fontSize}`,
                                                background: `${values?.customizeStyle?.buttonThemeColor}`,
                                                border: `1px solid ${values?.customizeStyle?.buttonThemeColor}`,
                                            }}
                                        >
                                            {previewLang === 'en'
                                                ? values?.customizeStyle
                                                      ?.acceptAllEn
                                                : values?.customizeStyle
                                                      ?.acceptAllTh}
                                        </Button>
                                    </div>
                                    <div
                                        hidden={
                                            !values?.customizeStyle?.rejectedAll
                                        }
                                    >
                                        <Button
                                            block={
                                                values?.customizeStyle
                                                    ?.position ===
                                                    POSITION_BANNER.TOP ||
                                                values?.customizeStyle
                                                    ?.position ===
                                                    POSITION_BANNER.BOTTOM
                                            }
                                            size="large"
                                            type="default"
                                            className={`h-auto ${positionButtonStyle?.buttonWidth} font-normal hover:opacity-80 hover:bg-[${values?.customizeStyle?.buttonThemeColor}] hover:border-[${values?.customizeStyle?.buttonThemeColor}] focus:bg-[${values?.customizeStyle?.buttonThemeColor}] focus:border-[${values?.customizeStyle?.buttonThemeColor}]`}
                                            onClick={() => setIsOpen(false)}
                                            style={{
                                                color: `${values?.customizeStyle?.buttonThemeColor}`,
                                                fontSize: `${values?.customizeStyle?.button?.fontSize}`,
                                                border: `1px solid ${values?.customizeStyle?.buttonThemeColor}`,
                                            }}
                                            ghost
                                        >
                                            {previewLang === 'en' ? (
                                                <>
                                                    {
                                                        values?.customizeStyle
                                                            ?.rejectedAllEn
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        values?.customizeStyle
                                                            ?.rejectedAllTh
                                                    }
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                    <div
                                        className="whitespace-nowrap align-middle font-semibold text-[#4ACE8F] underline cursor-pointer hover:text-[#4ACE8F] hover:opacity-80 items-center text-center"
                                        hidden={false}
                                        style={{
                                            color: `${values?.customizeStyle?.buttonThemeColor}`,
                                            fontSize: `${values?.customizeStyle?.button?.fontSize}`,
                                        }}
                                    >
                                        {previewLang === 'en' ? (
                                            <>
                                                {
                                                    values?.customizeStyle
                                                        ?.changePreferenceEn
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    values?.customizeStyle
                                                        ?.changePreferenceTh
                                                }
                                            </>
                                        )}
                                    </div>
                                </button>
                            </div>
                            <div
                                className="mt-4"
                                style={{
                                    borderBottom: '1px solid #ECECEC',
                                }}
                                hidden={positionButtonStyle?.showBorder}
                            ></div>
                            <div
                                className={`px-4 flex items-center my-1 text-[10px] text-[#A7A9AC] text-center md:text-left lg:text-left ${positionButtonStyle?.poweredPosition}`}
                                style={{
                                    color: `${values?.customizeStyle?.powerBy?.color}`,
                                    fontSize: `${values?.customizeStyle?.powerBy?.fontSize}`,
                                }}
                                hidden={!values?.customizeStyle?.hiddenLogo}
                            >
                                {t('COOKIE.PoweredBy')}
                                <span className="ml-2">{IconPowered}</span>
                            </div>
                            <button
                                type="button"
                                className="text-right cursor-pointer absolute top-[0.75rem] right-[1rem]"
                                onClick={() => setIsOpen(false)}
                                // hidden={(platform !== 'Desktop') && (values?.customizeStyle?.position === POSITION_BANNER.TOP_FULL || values?.customizeStyle?.position === POSITION_BANNER.BOTTOM_FULL) ? !values?.customizeStyle?.closeable:true}
                                hidden={
                                    (values?.customizeStyle?.position ===
                                        POSITION_BANNER.TOP_FULL &&
                                        platform === 'Desktop') ||
                                    (values?.customizeStyle?.position ===
                                        POSITION_BANNER.BOTTOM_FULL &&
                                        platform === 'Desktop')
                                        ? true
                                        : !values?.customizeStyle?.closeable
                                }
                            >
                                <svg
                                    style={{
                                        color: `${values?.customizeStyle?.buttonThemeColor}`,
                                    }}
                                    className="fill-current"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                >
                                    <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="relative"
                    hidden={!values?.customizeStyle?.alwaysDisplay}
                >
                    <div className={`absolute ${positionIconStyle}`}>
                        <button
                            type="button"
                            className="cursor-pointer"
                            onClick={() => setIsOpen(true)}
                        >
                            {values?.customizeStyle?.useDefaultIcon || !logo ? (
                                <svg
                                    width="69"
                                    height="70"
                                    viewBox="0 0 69 70"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="0.623072"
                                        y="0.623072"
                                        width="67.7539"
                                        height="68.5379"
                                        rx="33.8769"
                                        fill={`${values?.customizeStyle?.iconBackground}`}
                                    />
                                    <path
                                        d="M33.9708 54.3248C23.1038 54.3128 14.2989 45.392 14.2871 34.3855C15.0619 34.6069 15.8643 34.7205 16.6687 34.7225C17.9815 34.7318 19.2767 34.4177 20.4426 33.8074C21.6084 33.197 22.6097 32.3087 23.3601 31.2192C24.7243 29.2253 25.0122 26.671 24.1289 24.4159C24.6948 24.5176 25.2665 24.5694 25.8402 24.5714C27.101 24.5809 28.3477 24.3029 29.4877 23.7582C30.6277 23.2135 31.6317 22.416 32.4251 21.425C33.2025 20.4625 33.7565 19.3358 34.0462 18.128C34.3359 16.9202 34.3539 15.6621 34.0989 14.4463C44.9699 14.4822 53.753 23.4389 53.7156 34.4493C53.682 45.4618 44.8417 54.3607 33.9708 54.3248ZM35.4711 47.4816C35.7701 47.6092 36.0912 47.6757 36.4157 47.6774C36.7403 47.679 37.062 47.6158 37.3623 47.4913C37.6626 47.3667 37.9356 47.1834 38.1656 46.9518C38.3956 46.7202 38.578 46.4449 38.7024 46.1417C38.8888 45.6866 38.9379 45.1859 38.8435 44.7027C38.7492 44.2195 38.5155 43.7752 38.1721 43.426C37.8571 43.1094 37.4634 42.8849 37.0326 42.7761C36.6018 42.6673 36.1499 42.6784 35.7248 42.8082C35.2997 42.9379 34.9172 43.1815 34.6178 43.5132C34.3184 43.8448 34.1132 44.2522 34.024 44.6921C33.9109 45.2548 33.9933 45.8396 34.2574 46.3479C34.5214 46.8561 34.9508 47.2566 35.4731 47.4816H35.4711ZM23.9712 44.1059C24.7765 44.439 25.6796 44.435 26.4819 44.0947C27.2842 43.7544 27.92 43.1058 28.2494 42.2914C28.4531 41.7871 28.5312 41.2398 28.4769 40.6977C28.4226 40.1557 28.2375 39.6354 27.9379 39.1826C27.6383 38.7298 27.2334 38.3583 26.7587 38.1007C26.2839 37.8432 25.754 37.7074 25.2153 37.7054C24.3446 37.7075 23.5104 38.0589 22.8957 38.6825C22.281 39.306 21.9361 40.1508 21.9366 41.0313C21.9366 42.3652 22.7213 43.5696 23.9318 44.094H23.9633L23.9712 44.1059ZM42.5351 39.1072C43.1797 39.381 43.8941 39.4391 44.5737 39.273C45.2534 39.1069 45.8626 38.7253 46.3125 38.184C46.6083 37.8274 46.8269 37.412 46.954 36.9646C47.0811 36.5172 47.114 36.0478 47.0504 35.5868C46.9869 35.1258 46.8283 34.6834 46.5851 34.2883C46.3418 33.8931 46.0192 33.554 45.6382 33.2929C45.1386 32.9496 44.5548 32.7528 43.9514 32.724C43.3481 32.6953 42.7486 32.8358 42.2192 33.13C41.6899 33.4242 41.2512 33.8607 40.9517 34.3912C40.6522 34.9217 40.5036 35.5256 40.5221 36.1362C40.5557 37.3824 41.2713 38.503 42.3813 39.0433H42.3576L42.4168 39.0693L42.4562 39.0852H42.4444C42.4725 39.0944 42.5001 39.105 42.5272 39.1171L42.5351 39.1072ZM33.9708 31.0617C33.5635 31.0607 33.1704 31.2128 32.8678 31.4885C32.5651 31.7642 32.3746 32.1438 32.3332 32.5535C32.2917 32.9633 32.4023 33.3741 32.6434 33.706C32.8846 34.038 33.2391 34.2674 33.6381 34.3499C34.0372 34.4324 34.4523 34.3619 34.8028 34.1523C35.1534 33.9426 35.4144 33.6087 35.5353 33.2153C35.6561 32.8219 35.628 32.3972 35.4566 32.0235C35.2852 31.6499 34.9826 31.354 34.6076 31.1933L34.5721 31.1773L34.5189 31.1574C34.343 31.0938 34.1576 31.0614 33.9708 31.0617ZM41.3522 22.755C40.7439 22.7546 40.1572 22.9824 39.7055 23.3943C39.2539 23.8062 38.9693 24.373 38.907 24.9849C38.8447 25.5967 39.009 26.2102 39.3682 26.7066C39.7274 27.203 40.2559 27.547 40.8514 27.672C41.4453 27.7888 42.0608 27.68 42.5804 27.3664C43.0999 27.0529 43.4868 26.5566 43.6672 25.9726C43.8476 25.3885 43.8087 24.7577 43.558 24.2009C43.3073 23.644 42.8623 23.2002 42.3083 22.9544H42.2886C41.9925 22.8262 41.6742 22.7584 41.3522 22.755ZM19.208 29.4007C18.7727 29.4005 18.3554 29.2253 18.0477 28.9138C17.7401 28.6023 17.5675 28.18 17.5677 27.7398C17.568 27.2995 17.7412 26.8774 18.0491 26.5663C18.3571 26.2552 18.7747 26.0806 19.21 26.0808C19.4255 26.081 19.6389 26.124 19.838 26.2076C20.0371 26.2911 20.218 26.4135 20.3703 26.5677C20.5226 26.722 20.6434 26.905 20.7257 27.1065C20.8081 27.3079 20.8504 27.5238 20.8503 27.7418C20.8502 27.9598 20.8076 28.1756 20.725 28.3769C20.6424 28.5783 20.5214 28.7612 20.3689 28.9152C20.2164 29.0693 20.0354 29.1915 19.8362 29.2748C19.637 29.358 19.4236 29.4009 19.208 29.4007ZM16.7476 24.4159C16.0945 24.4154 15.4684 24.1525 15.0069 23.6851C14.5455 23.2177 14.2866 22.584 14.2871 21.9235C14.2876 21.263 14.5476 20.6298 15.0097 20.1631C15.4719 19.6964 16.0984 19.4346 16.7515 19.4351C17.0749 19.4354 17.395 19.5 17.6937 19.6254C17.9923 19.7508 18.2637 19.9345 18.4921 20.1659C18.7206 20.3974 18.9018 20.6721 19.0253 20.9743C19.1488 21.2766 19.2122 21.6004 19.212 21.9275C19.2117 22.2545 19.1478 22.5783 19.0238 22.8804C18.8998 23.1824 18.7182 23.4568 18.4893 23.6879C18.2605 23.919 17.9889 24.1022 17.69 24.2271C17.3912 24.352 17.0709 24.4162 16.7476 24.4159ZM26.5894 21.092C25.9358 21.0915 25.3092 20.8284 24.8474 20.3606C24.3856 19.8928 24.1264 19.2587 24.127 18.5976C24.1275 17.9366 24.3876 17.3029 24.8502 16.8358C25.3127 16.3688 25.9397 16.1067 26.5933 16.1072C27.2472 16.1078 27.8741 16.371 28.3361 16.8389C28.798 17.3069 29.0573 17.9413 29.0568 18.6026C29.0562 19.2639 28.796 19.8979 28.3333 20.3651C27.8706 20.8324 27.2433 21.0946 26.5894 21.094V21.092ZM20.8503 17.7702C20.6348 17.7702 20.4213 17.7272 20.2222 17.6438C20.0231 17.5604 19.8421 17.4381 19.6897 17.284C19.5373 17.1298 19.4164 16.9468 19.3339 16.7455C19.2515 16.5441 19.209 16.3282 19.209 16.1102C19.209 15.8922 19.2515 15.6764 19.3339 15.475C19.4164 15.2736 19.5373 15.0906 19.6897 14.9365C19.8421 14.7823 20.0231 14.6601 20.2222 14.5766C20.4213 14.4932 20.6348 14.4503 20.8503 14.4503C21.2856 14.4503 21.7031 14.6252 22.0109 14.9365C22.3187 15.2478 22.4916 15.67 22.4916 16.1102C22.4916 16.5505 22.3187 16.9727 22.0109 17.284C21.7031 17.5953 21.2856 17.7702 20.8503 17.7702Z"
                                        fill={`${values?.customizeStyle?.iconColor}`}
                                    />
                                    <rect
                                        x="0.623072"
                                        y="0.623072"
                                        width="67.7539"
                                        height="68.5379"
                                        rx="33.8769"
                                        stroke="#B7B7C0"
                                        strokeWidth="1.24614"
                                    />
                                </svg>
                            ) : (
                                <img
                                    src={logo}
                                    className="h-[47px] w-[47px]"
                                    alt="logo"
                                />
                            )}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CookieConsent;

const IconPowered = (
    <svg
        width="20"
        height="20"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="7.90039" cy="7" r="7" fill="#7B67FB" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.16732 11.1727V11.1757H4.40039V11.547H7.12725C7.65679 11.547 8.17416 11.4405 8.65502 11.2427C9.13587 11.0448 9.57411 10.7527 9.94845 10.3784C10.3228 10.004 10.6149 9.56273 10.8128 9.08492C11.0106 8.60407 11.1171 8.0867 11.1171 7.55716V7.125H10.7428V7.55716C10.7428 8.51582 10.3623 9.43491 9.68367 10.1136C9.005 10.7922 8.08591 11.1727 7.12725 11.1727H5.16732Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.40332 9.643H4.77765V6.53572C4.77765 5.59837 5.14894 4.70057 5.8124 4.03712C6.47585 3.37367 7.37364 3.00238 8.311 3.00238H10.0366V2.9902H11.12V2.625H8.31404C7.79667 2.625 7.28843 2.72847 6.81671 2.92325C6.34803 3.11803 5.91587 3.4041 5.54763 3.76931C5.17938 4.13451 4.8933 4.56667 4.70157 5.03839C4.50679 5.50707 4.40332 6.01531 4.40332 6.53572V9.643Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1128 5.72285V5.35156H8.15768C8.02073 5.35156 7.88682 5.37895 7.76204 5.43069C7.63726 5.48243 7.52466 5.55851 7.42727 5.65286C7.32988 5.75024 7.2538 5.86285 7.2051 5.98763C7.15337 6.1124 7.12598 6.24631 7.12598 6.38326V6.47456C7.12598 6.61152 7.15337 6.74542 7.2051 6.8702C7.25684 6.99498 7.33293 7.10758 7.42727 7.20497C7.52466 7.30236 7.63726 7.37844 7.76204 7.42714C7.88682 7.47583 8.02073 7.50626 8.15768 7.50626H11.1128V7.12889H10.7354V7.13193C10.7354 7.13193 9.10112 7.13193 8.15768 7.13193C7.98421 7.13193 7.81682 7.06193 7.69509 6.9402C7.57335 6.81846 7.50335 6.65108 7.50335 6.47761C7.50335 6.44717 7.50335 6.41674 7.50335 6.38631C7.50335 6.21283 7.57335 6.04545 7.69509 5.92371C7.81682 5.80198 7.98421 5.73198 8.15768 5.73198H10.6806V5.7259H11.1128V5.72285Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.73566 6.27867C5.79044 5.65783 6.07956 5.11002 6.50868 4.71743C6.93779 4.32179 7.51299 4.08441 8.13688 4.08441H11.1194V3.70703H8.13688C7.4156 3.70703 6.75215 3.98398 6.25303 4.44048C5.75392 4.89699 5.4222 5.53305 5.36133 6.25128L5.55002 6.45519L5.36133 6.2665V9.63855L5.73871 9.64159V6.27867H5.73566Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.59473 7.92359C9.53995 8.54443 9.25083 9.09224 8.82171 9.48483C8.3926 9.88047 7.8174 10.1179 7.19352 10.1179H4.41797V10.4952H7.19352C7.91479 10.4952 8.57825 10.2183 9.07736 9.76178C9.57647 9.30527 9.9082 8.66921 9.96906 7.95098V7.9388L9.98732 7.18101L9.60995 7.17188L9.59473 7.92359Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1078 4.57422H8.04308C7.81483 4.57422 7.58962 4.61987 7.37963 4.70508C7.17268 4.7903 6.98095 4.91812 6.81965 5.07942C6.65835 5.24072 6.53053 5.43245 6.44532 5.6394C6.3601 5.84635 6.31445 6.07155 6.31445 6.30285L6.50314 6.49154L6.31445 6.30285V7.55367H6.69183V6.30285L6.50314 6.49154L6.69183 6.30285C6.69183 6.12329 6.72835 5.94678 6.7953 5.78548C6.86226 5.62418 6.96269 5.47201 7.08747 5.34723C7.21529 5.21941 7.36441 5.12202 7.52571 5.05507C7.68701 4.98812 7.86352 4.9516 8.04308 4.9516H11.1078V4.57422Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.30859 9.63128H7.28551C7.51377 9.63128 7.73898 9.58563 7.94897 9.50041C8.15592 9.4152 8.34765 9.28738 8.50895 9.12608C8.67025 8.96478 8.79807 8.77305 8.88328 8.5661C8.9685 8.35915 9.01415 8.13394 9.01415 7.90265L8.82546 8.09133L9.01415 7.90265V7.21484H8.63677V7.90265L8.82546 8.09133L8.63677 7.90265C8.63677 8.0822 8.60025 8.25872 8.53329 8.42002C8.46634 8.58132 8.36591 8.73348 8.24113 8.85826C8.11331 8.98608 7.96418 9.08347 7.80289 9.15043C7.64159 9.21738 7.46507 9.2539 7.28551 9.2539H6.30859V9.63128Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.84256 7.20312V7.60789C7.84256 7.80875 7.76039 7.98831 7.62953 8.12222C7.49866 8.25309 7.31606 8.33526 7.1152 8.33526H6.30566V8.70959H7.1152C7.41954 8.70959 7.69344 8.58481 7.8943 8.38699C8.09516 8.18613 8.2169 7.91223 8.2169 7.60789V7.39181L8.05256 7.27312L7.84256 7.20312Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.69554 6.67866L11.1059 6.6391L11.0998 6.26172L8.68945 6.30128L8.69554 6.67866Z"
            fill="white"
        />
    </svg>
);
